/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Sync_Existing_SystemsInputs */



/**
* | output |
* | --- |
* | "Bring in knowledge from our systems" |
*
* @param {Uno_Welcome_Suggestion_Sync_Existing_SystemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_sync_existing_systems = /** @type {((inputs?: Uno_Welcome_Suggestion_Sync_Existing_SystemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Sync_Existing_SystemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wissen aus unseren Systemen einbinden")
	return /** @type {LocalizedString} */ ("Bring in knowledge from our systems")
});